import { EPlanType } from '@if/core/types'
import { copyMessage } from '@if/core/utils'
import CopyAllIcon from '@mui/icons-material/CopyAll'
import { Button, Grid, IconButton, Stack } from '@mui/material'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { InputTextField } from '../../../components'
import { AutoWorksheet, CreditApplication } from '../../../data/types'
import { Merchant } from '../../../data/types/Merchant'

interface Props {
  worksheet: AutoWorksheet
  creditApplication: CreditApplication
  merchant: Merchant | null
  onSubmit: () => void
  onSaveDraft: () => void
}

const ProgramSectionEdit = ({
  worksheet,
  creditApplication,
  merchant,
  onSubmit,
  onSaveDraft,
}: Props): JSX.Element | null => {
  const { t } = useTranslation()
  const planName =
    worksheet.brokerRequestedFinancingPlan ?? creditApplication.normsCreditDecision?.planName ?? EPlanType.Default

  return (
    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', mt: 3, p: 2 }}>
      <Grid
        sx={{ flexDirection: 'row' }}
        size={{
          xs: 6,
          md: 2.7,
        }}
      >
        <InputTextField label={t('worksheet.program')} disabled value={t(`EPlanType.${planName}`, { ns: 'enum' })} />
      </Grid>
      <Grid
        sx={{ flexDirection: 'row' }}
        size={{
          xs: 6,
          md: 2.7,
        }}
      >
        <InputTextField
          label="Province"
          disabled
          value={merchant?.province ? t(`EProvince.${merchant?.province}`, { ns: 'enum' }) : ''}
        />
      </Grid>
      <Grid
        sx={{ flexDirection: 'row' }}
        size={{
          xs: 6,
          md: 2.7,
        }}
      >
        <InputTextField
          label={t('editCreditApplication.address.postalCode')}
          value={merchant?.zipCode}
          disabled
          slotProps={{
            input: {
              endAdornment: (
                <IconButton onClick={() => merchant?.zipCode && copyMessage(merchant?.zipCode)}>
                  <CopyAllIcon />
                </IconButton>
              ),
            },
          }}
        />
      </Grid>
      <Grid
        sx={{ flexDirection: 'row' }}
        size={{
          xs: 6,
          md: 3.9,
        }}
      >
        <Stack direction="row" justifyContent="flex-end" spacing={3}>
          <Button variant="contained" color="secondary" onClick={onSaveDraft}>
            {t('worksheet.saveDraft')}
          </Button>
          <Button variant="contained" color="primary" type="submit" value="finale" onClick={onSubmit}>
            {t('worksheet.submit')}
          </Button>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default ProgramSectionEdit
